<template>
    <div class="pagination display--flex" role="naviagation" :aria-label="$t('accessibility.pagination')">
        <button-with-icon
            :icon="{
                component: () => import( /* webpackChunkName: 'IconArrow' */ '@/components/bundles/layout/images/icons/IconArrow' ),
                class: `pagination__arrow pagination__arrow--left ${ activeLeftArrow ? 'pagination__arrow--active' : '' }`
            }"
            :class="[
                'pagination__arrow__button',
                { 'disable': ! activeLeftArrow }
            ]"
            v-bind="{
                ...(
                    activeLeftArrow
                        ? { 'aria-label': $t( 'accessibility.goTo', { page: pagination ? pagination.currentPage - 1 : 0 }) }
                        : { tabindex: -1 }
                )
            }"
            :action="{
                execute: activeLeftArrow,
                function: () => navigate( 'previous' )
            }"
        />
        <span class="pagination__info">{{ label }}</span>
        <button-with-icon
            :icon="{
                component: () => import( /* webpackChunkName: 'IconArrow' */ '@/components/bundles/layout/images/icons/IconArrow' ),
                class: `pagination__arrow pagination__arrow--right ${ activeRightArrow ? 'pagination__arrow--active' : '' }`
            }"
            :class="[
                'pagination__arrow__button',
                { 'disable': ! activeRightArrow }
            ]"
            v-bind="{
                ...(
                    activeRightArrow
                        ? { 'aria-label': $t( 'accessibility.goTo', { page: pagination ? pagination.currentPage + 1 : 0 }) }
                        : { tabindex: -1 }
                )
            }"
            :action="{
                execute: activeRightArrow,
                function: () => navigate()
            }"
        />
    </div>
</template>

<script>
// packages
import { reactive, toRefs, watch } from '@vue/composition-api';

// i18n
import i18n from '@/plugins/i18n';

export default {
    components: {
        ButtonWithIcon: () => import( /* webpackChunkName: 'ButtonWithIcon' */ '@/components/bundles/buttons/BaseButtonWithIcon' )
    },
    props: {
        pagination: Object
    },
    setup ( props, { root: { $router, $route } }) {
        const state = reactive({
            label: `0-0 ${i18n.t( 'global.of' )} 0`,
            activeLeftArrow: false,
            activeRightArrow: false
        });

        watch( () => props.pagination,
            newPagination => {
                // se a nova paginação for nula,
                // não executa o resto do código.
                if ( !newPagination )
                    return;

                // obtenção do range.
                const [ firstElement, lastElement ] = props.pagination.range;

                // definição da nova label da paginação.
                state.label = `${firstElement}-${lastElement} ${i18n.t( 'global.of' )} ${props.pagination.total}`;
                // verificação se a página actual é superior a primeira página.
                state.activeLeftArrow = newPagination.currentPage > 1;
                // verificação se a página actual é inferior ao total de páginas.
                state.activeRightArrow = newPagination.currentPage < newPagination.totalPages;
            }, {
                immediate: true
            });

        const navigate = ( orientation = 'next' ) => {
            // validação de qual é a orientação.
            const newPage = orientation === 'next'
                ? props.pagination.currentPage + 1
                : props.pagination.currentPage - 1;

            // construção da query.
            const query = { ...$route.query, ...{ page: newPage } };

            $router.push({ query });
        };

        return { ...toRefs( state ), navigate };
    }
};
</script>

<style lang="scss">
    // =============================================================================
    // Variables
    // =============================================================================
    $arrowClass: '.pagination__arrow';

    // =============================================================================
    // Style
    // =============================================================================
    .pagination {
        justify-content: center;
        &__info {
            margin: 0 40px;
        }
        &__arrow {
            @include transition( transform .2s ease-in-out );
            will-change: transform;
            & .path {
                @include transition( all .2s ease-in-out );
            }
            &--left {
                @include transform( rotate( 180deg ) );
            }
            &--active {
                & .path {
                    fill: $color-green;
                }
                &#{$arrowClass}  {
                    &--left {
                        &:hover {
                            @include transform( translateX( -5px ) rotate( 180deg ) );
                        }
                    }
                    &--right {
                        &:hover {
                            @include transform( translateX( 5px ) );
                        }
                    }
                }
            }
        }
    }
</style>